import { FormControlLabel } from "@mui/material";

import MyDialog from "~/mui/MyDialog";
import { useTrans } from '~/hooks/useTrans';
import { apiToggleProjectCatalogPublishStatus } from '~/providers/api';
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";
import { IClientProjectCatalog } from "~/providers/client-interfaces";
import { IUrlParams } from "~/interfaces";
import { MySwitch } from "~/mui/MySwitch";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
	published: boolean;
}

interface IEditProjectCatalogModal {
	params: IUrlParams;
	isInternal: boolean;
	catalogData: IClientProjectCatalog;
	onClose?: () => void;
	onSave?: (catalog: IClientProjectCatalog) => void;
}

export default function EditProjectCatalogPublishModal({
	params,
	isInternal = false,
	catalogData = null,
	onClose = () => {},
	onSave = () => {},
}: IEditProjectCatalogModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
		published: catalogData.published,
	});

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		const outputData = await apiToggleProjectCatalogPublishStatus(isInternal ? "admin" : "client", params.projectId, catalogData.id, state.published, lang);

		if (outputData.noErrors) {
			updateState({
				dialogLoading: false,
			});
			onSave(outputData.data);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: outputData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("editProjectCatalogPublishModal.mainTitle")} onClose={onClose} onSave={dialogOnSave} contentClassName="editProjectCatalogPublishModal" dialogLoading={state.dialogLoading}
		errorMsg={state.errorMsg} saveCaption={trans("saveChanges")} cancelCaption={trans("close")}>
		<FormControlLabel
			className="adminProjectsFiler__mySwitch"
			control={<MySwitch sx={{ m: 1 }} checked={state.published} onChange={event => updateState({ published: event.target.checked })} />}
			label={trans("editProjectCatalogPublishModal.info")}
			sx={{ marginBottom: "var(--margin-large)" }}
		/>
	</MyDialog>;
}
